module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gis-map-compare-separator\">\n    <div class=\"top\">\n        <span class=\"icon-16 icon-arrow-down2\"></span>\n    </div>\n    <div class=\"bottom\">\n        <span class=\"icon-16 icon-arrow-up2\"></span>\n    </div>\n</div>")
  }
  return __output.join("");

}